<template>
  <div class="nav-side-container">
    <!-- 侧边导航 -->
    <div class="nav-side" ref="navSide">
      <ul>
        <li :class="{'active': panelActiveIndex == (index+1)}" 
          @mouseenter="showDetail(index+1)" 
          @mouseleave="hideDetail()"
          v-for="(item, index) in  classifyList" :key="'navSide_'+item.id">
          <div class="nav-side-main">
            <router-link :to="'/list/'+item.id">
              {{item.name}}
            </router-link>
          </div>
          <div class="nav-side-item">
            <template v-for="(value, n) in item.children">
              <span :key="'navSideItem_'+value.id" v-if="n < 3">
                <router-link :to="'/list/'+value.id">
                  {{value.name}}
                </router-link>
              </span>
            </template>
          </div>
        </li>
      </ul>
    </div>
    <div class="detail-item-panel-box"  ref="itemPanel">
      <template v-for="(classify, n) in  classifyList">
        <div class="detail-item-panel" 
          :key="'itemPanel_'+n"
          v-show="panelActiveIndex == (n+1)" 
          @mouseenter="showDetail(n+1)"  
          @mouseleave="hideDetail()"
          v-if="classify.children">
          <ul>
            <li v-for="(items, index) in classify.children" :key="index" class="detail-item-row">
              <div class="detail-item-title">
                <router-link :to="'/list/'+items.id">
                  {{items.name}}
                </router-link>
              </div>
              <template v-for="(item, subIndex) in items.children">
                <router-link :to="'/list/'+item.id" :key="subIndex" v-if="subIndex < 3">
                  <span class="detail-item">{{item.name}}</span>
                </router-link>
              </template>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'GoodsListNavSide',
  data () {
    return {
      panelActiveIndex: 0
    };
  },
  computed: {
    ...mapState(['classifyList'])
  },
  watch: {
    "$route"() {
      this.panelActiveIndex = 0
    }
  },
  mounted () {
    this.$refs.itemPanel.style.left = this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
    this.$refs.itemPanel.style.top = this.$refs.navSide.offsetTop + 'px';
  },
  updated () {
    this.$refs.itemPanel.style.left = this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
    this.$refs.itemPanel.style.top = this.$refs.navSide.offsetTop + 'px';
  },
  methods: {
    showDetail (index) {
      this.panelActiveIndex = index
    },
    hideDetail () {
      this.panelActiveIndex = 0
    }
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/nav-side";

.detail-item-panel-box {
  position: absolute;
  top: 0px;
  left: @left-side-width;
}

</style>



// WEBPACK FOOTER //
// src/components/nav/GoodsListNavSide.vue